// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AudioOutlinedSvg from "@ant-design/icons-svg/es/asn/AudioOutlined";
import AntdIcon from '../components/AntdIcon';

var AudioOutlined = function AudioOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AudioOutlinedSvg
  }));
};

AudioOutlined.displayName = 'AudioOutlined';
export default React.forwardRef(AudioOutlined);